import React from 'react'
import { useLocation } from 'react-router-dom';
import { GlobalPublications } from '../GlobalPublications'

const Publications = () => {
  const locationReact = useLocation();
  const userKey = new URLSearchParams(locationReact.search).get('authCode');

  return (
    <div className='central-main-content' style={{ margin: 'auto' }}>
      <GlobalPublications where={!userKey ? "user" : "oUser"} key={userKey ?? 'me'} />
    </div>
  )
}

export default Publications